import React from 'react'
import {
  BooleanField,
  Datagrid,
  TextField,
  SelectInput,
  useTranslate,
  TextInput
} from 'react-admin'

import { ListBase } from '../../components/base'
import { DateField } from '../../components/fields'
import { COMMON_FIELDS, CATALOGUES_FIELDS } from '../../providers/localization/constant'

const CataloguesList = (): JSX.Element => {
  const translate = useTranslate()
  const CataloguesListFilters = [
    <TextInput
      key={0}
      source='title'
      // InputLabelProps={{ shrink: true }}
      // InputProps={{ notched: false }}
      // placeholder={translate(`${PRODUCTS_COMMON_FIELDS}.prod_code.label`)}
      label={translate(`${CATALOGUES_FIELDS}.title`)}
    />,
    <TextInput
      key={0}
      source='description'
      // InputLabelProps={{ shrink: true }}
      // InputProps={{ notched: false }}
      // placeholder={translate(`${PRODUCTS_COMMON_FIELDS}.prod_code.label`)}
      label={translate(`${CATALOGUES_FIELDS}.description`)}
    />,
    <TextInput
      key={0}
      source='period'
      // InputLabelProps={{ shrink: true }}
      // InputProps={{ notched: false }}
      // placeholder={translate(`${PRODUCTS_COMMON_FIELDS}.prod_code.label`)}
      label={translate(`${CATALOGUES_FIELDS}.period`)}
    />,
    <SelectInput
      key={1}
      label={`${COMMON_FIELDS}.status.label`}
      source='is_active'
      choices={[
        { id: 'true', name: `${COMMON_FIELDS}.status.choices.active` },
        { id: 'false', name: `${COMMON_FIELDS}.status.choices.inActive` },
      ]}
    />,
  ]
  return (
    <ListBase
      listAction={{
        hasExport: false,
      }}
      filters={CataloguesListFilters}
      sort={{ field: 'create_at', order: 'DESC' }}
    >
      <Datagrid rowClick='edit'>
        <TextField source='title_th' label={`${CATALOGUES_FIELDS}.title_th`}></TextField>
        <TextField source='title_en' label={`${CATALOGUES_FIELDS}.title_en`}></TextField>
        <TextField source='description_th' label={`${CATALOGUES_FIELDS}.description_th`}></TextField>
        <TextField source='description_en' label={`${CATALOGUES_FIELDS}.description_en`}></TextField>
        <TextField source='period_th' label={`${CATALOGUES_FIELDS}.period_th`}></TextField>
        <TextField source='period_en' label={`${CATALOGUES_FIELDS}.period_en`}></TextField>
        <TextField source='file.original_name' label={`${CATALOGUES_FIELDS}.file.name`} sortable={false}></TextField>
        <DateField
          source='create_at'
          label={`${COMMON_FIELDS}.date.created_at`}
          textAlign='center'
        />
        <DateField
          source='update_at'
          label={`${COMMON_FIELDS}.date.updated_at`}
          textAlign='center'
        />
        <BooleanField
          source='is_active'
          label={`${COMMON_FIELDS}.status.label`}
          textAlign='center'
          sortable={false}
        />
      </Datagrid>
    </ListBase>
  )
}

export default CataloguesList